import V3API from '@/api/v3';

const GET_QUEUE = 'GET_QUEUE';
const GET_QUEUE_FAILED = 'GET_QUEUE_FAILED';
const GET_QUEUE_SUCCESS = 'GET_QUEUE_SUCCESS';

const GET_QUEUES = 'GET_QUEUES';
const GET_QUEUES_FAILED = 'GET_QUEUES_FAILED';
const GET_QUEUES_SUCCESS = 'GET_QUEUES_SUCCESS';

// @ Default Data ==================
const GET_QUEUE_DATA = 'GET_QUEUE_DATA';
const GET_QUEUE_DATA_FAILED = 'GET_QUEUE_DATA_FAILED';
const GET_QUEUE_DATA_SUCCESS = 'GET_QUEUE_DATA_SUCCESS';

const namespaced = true;

const state = {
  loading: false,
  queue: {},
  queueList: [],
};

const getters = {
  isLoading: (state) => {
    return state.loading;
  },

  getQueue: (state) => {
    return state.queue;
  },

  getQueueList: (state) => {
    return state.queueList;
  },
};

const actions = {
  //* Create new queue for event/clubhouse
  async queueCreate({ commit }, payload) {
    let response;

    commit(GET_QUEUE);

    try {
      response = await V3API.queues.queueCreate(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_QUEUE_FAILED);
        reject(response);
      } else {
        commit(GET_QUEUE_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* List all queues with users for event/clubhouse
  async queueList({ commit }, payload) {
    let response;

    commit(GET_QUEUES);

    try {
      response = await V3API.queues.queueList(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_QUEUES_FAILED);
        reject(response);
      } else {
        commit(GET_QUEUES_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* Get single queue details
  async queueGet({ commit }, payload) {
    let response;

    commit(GET_QUEUE);

    try {
      response = await V3API.queues.queueGet(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_QUEUE_FAILED);
        reject(response);
      } else {
        commit(GET_QUEUE_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* Delete entire queue
  async queueDelete({ commit }, payload) {
    let response;

    commit(GET_QUEUE_DATA);

    try {
      response = await V3API.queues.queueDelete(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_QUEUE_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_QUEUE_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* Empty queue users
  async queueEmpty({ commit }, payload) {
    let response;

    commit(GET_QUEUE_DATA);

    try {
      response = await V3API.queues.queueEmpty(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_QUEUE_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_QUEUE_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* Unbind queue from sim
  async queueUnbind({ commit }, payload) {
    let response;

    commit(GET_QUEUE_DATA);

    try {
      response = await V3API.queues.queueUnbind(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_QUEUE_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_QUEUE_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* Add user to queue
  async queueAddUser({ commit }, payload) {
    let response;

    commit(GET_QUEUE_DATA);

    try {
      response = await V3API.queues.queueAddUser(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_QUEUE_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_QUEUE_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* Remove user from queue
  async queueRemoveUser({ commit }, payload) {
    let response;

    commit(GET_QUEUE_DATA);

    try {
      response = await V3API.queues.queueRemoveUser(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_QUEUE_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_QUEUE_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* Reorder user in queue list
  async queueReorderUser({ commit }, payload) {
    let response;

    commit(GET_QUEUE_DATA);

    try {
      response = await V3API.queues.queueReorderUser(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_QUEUE_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_QUEUE_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* Transfer user from one queue to another
  async queueTransferUser({ commit }, payload) {
    let response;

    commit(GET_QUEUE_DATA);

    try {
      response = await V3API.queues.queueTransferUser(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_QUEUE_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_QUEUE_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* Set user state in queue - active/disabled
  async queueSetUserState({ commit }, payload) {
    let response;

    commit(GET_QUEUE_DATA);

    try {
      response = await V3API.queues.queueSetUserState(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_QUEUE_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_QUEUE_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },
};

const mutations = {
  [GET_QUEUE_DATA](state) {
    state.loading = true;
  },

  [GET_QUEUE_DATA_SUCCESS](state) {
    state.loading = false;
  },

  [GET_QUEUE_DATA_FAILED](state) {
    state.loading = false;
  },

  [GET_QUEUE](state) {
    state.loading = true;
  },

  [GET_QUEUE_FAILED](state) {
    state.loading = false;
  },

  [GET_QUEUE_SUCCESS](state, data) {
    state.queue = data;
    state.loading = false;
  },

  [GET_QUEUES](state) {
    state.loading = true;
  },

  [GET_QUEUES_FAILED](state) {
    state.loading = false;
  },

  [GET_QUEUES_SUCCESS](state, data) {
    state.queueList = data;
    state.loading = false;
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
